import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatPrice(value: number | string, precision?: number) {
  const val = typeof value === 'string' ? parseFloat(value) : value;
  if (isNaN(val)) return '0';
  
  const maxPrec = precision ?? guessPricePrecision(val);
  
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: maxPrec,
  }).format(val);
}

function guessPricePrecision(value: number): number {
  const abs = Math.abs(value);
  if (abs >= 1000) return 2;
  if (abs >= 1) return 4;
  if (abs >= 0.01) return 6;
  if (abs >= 0.0001) return 8;
  if (abs >= 0.000001) return 10;
  return 12;
}

export function formatQty(value: number | string, precision?: number) {
  const val = typeof value === 'string' ? parseFloat(value) : value;
  if (isNaN(val)) return '0';
  
  const maxPrec = precision ?? guessQtyPrecision(val);
  
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: maxPrec,
  }).format(val);
}

function guessQtyPrecision(value: number): number {
  const abs = Math.abs(value);
  if (abs >= 10000) return 0;
  if (abs >= 100) return 2;
  if (abs >= 1) return 4;
  if (abs >= 0.001) return 6;
  if (abs >= 0.00001) return 8;
  return 10;
}

export function formatKstTime(dateStr: string) {
  if (!dateStr) return 'N/A';
  const d = new Date(dateStr);
  const kst = new Date(d.getTime() + 9 * 3600000);
  const y = kst.getUTCFullYear();
  const m = String(kst.getUTCMonth() + 1).padStart(2, '0');
  const day = String(kst.getUTCDate()).padStart(2, '0');
  const h = String(kst.getUTCHours()).padStart(2, '0');
  const min = String(kst.getUTCMinutes()).padStart(2, '0');
  const sec = String(kst.getUTCSeconds()).padStart(2, '0');
  return `${y}-${m}-${day} ${h}:${min}:${sec}`;
}

export function formatRemainingHours(startedAtStr: string, durationMs: number = 24 * 60 * 60 * 1000) {
  if (!startedAtStr) return '0시간 0분';
  const startedAt = new Date(startedAtStr).getTime();
  const now = new Date().getTime();
  const remaining = Math.max(0, (startedAt + durationMs) - now);
  const hours = Math.floor(remaining / (1000 * 60 * 60));
  const minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
  return `${hours}시간 ${minutes}분`;
}
